@if (visible()) {
      <div [class]="'fixed inset-0 z-modal flex items-center justify-center ' + positionClasses()">
        <!-- Backdrop -->
        @if (config().modal !== false) {
          <div
            class="absolute inset-0 bg-black/60 backdrop-blur-sm"
            [class.cursor-pointer]="config().dismissableMask"
            (click)="onBackdropClick()">
          </div>
        }

        <!-- Dialog -->
        <div
          class="relative z-10 animate-in fade-in zoom-in-95 duration-200"
          [style.width]="config().width || '50vw'"
          [style.height]="config().height || 'auto'"
          [style.minWidth]="config().minWidth"
          [style.minHeight]="config().minHeight"
          [style.maxWidth]="config().maxWidth || '90vw'"
          [style.maxHeight]="config().maxHeight || '90vh'"
          [class]="dialogClasses()"
          role="dialog"
          [attr.aria-modal]="config().modal !== false"
          [attr.aria-labelledby]="config().ariaLabelledBy || (config().header && config().showHeader !== false ? 'dialog-header' : undefined)"
          [attr.aria-label]="config().showHeader === false && !config().ariaLabelledBy ? config().header : undefined"
          [attr.aria-describedby]="config().ariaDescribedBy || undefined">

          <!-- Header -->
          @if (config().showHeader !== false && config().header) {
            <div class="flex items-center justify-between p-4 border-b border-bb-border">
              <h2
                id="dialog-header"
                class="text-lg font-semibold text-bb-text-primary">
                {{ config().header }}
              </h2>
              @if (config().closable !== false) {
                <button
                  type="button"
                  class="p-2 rounded-lg text-bb-text-secondary hover:text-bb-text-primary hover:bg-bb-bg-tertiary transition-colors"
                  (click)="close()"
                  aria-label="Close dialog">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12"/>
                  </svg>
                </button>
              }
            </div>
          }

          <!-- Content -->
          <div
            class="overflow-auto"
            [style]="contentStyle()"
            [style.maxHeight]="contentMaxHeight()">
            <ng-container #contentContainer></ng-container>
          </div>

          <!-- Footer -->
          @if (config().footer) {
            <div class="p-4 border-t border-bb-border text-bb-text-secondary" data-testid="dialog-footer">
              {{ config().footer }}
            </div>
          }
        </div>
      </div>
    }
